<template>
  <div class="bg-light-gray px-4 rounded">
    <div class="row p-3">
      <div class="col-12 pl-0">
        <icon-view
          icon="fas fa-plus-circle text-orange"
          variant="custom-icon-view"
          icon-background="white"
          title="Solicitar por Compra"
        />
      </div>
    </div>
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-md-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="reasons"
              label="Razón:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione una razón"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una razón"
              :error="errors[0]"
              v-model="model.reason"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="color-black font-16 my-1">
              Comentario:
            </div>
            <custom-text-area
              v-model="model.comment"
              show-char-count
              custom-error-msg="Favor escriba un comentario"
              placeholder="Escribe un comentario"
              :count-classes="['d-block', 'small-counter', 'text-right']"
              :error="errors[0]"
              :maxlength="3000"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4 pb-3">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="cancel"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Someter"
        variant="success px-3"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import CustomDropDown from "custom-drop-down";
import orderService from "@/services/api/inventoryOrderBooks.api";
import catalogService from "@/services/api/inventorycatalog.api";
import ReasonTypes from "@/utils/constants/inventory/reasonTypes";
import alertMixin from "@/mixin/alert.mixin";

export default {
  name: "RequestToPurchase",
  mixins: [alertMixin],
  components: {
    IconView,
    CustomTextArea,
    ActionButton,
    CustomDropDown
  },
  props: {
    orderId: {
      type: Number,
      default: () => 0
    }
  },
  data: () => ({
    reasons: [],
    model: {
      reasonId: null,
      comment: null
    }
  }),
  mounted() {
    this.getReasons();
  },
  methods: {
    async getReasons() {
      const { data } = await catalogService.getReasonsByType(
        ReasonTypes.SifdeRequest
      );
      this.reasons = data;
    },
    async submit() {
      const valid = await this.$refs.formModalObserver.validate();
      if (!valid) return;
      try {
        const { reason, comment } = this.model;
        const payload = {
          reasonId: reason?.id,
          comment
        };
        await orderService.requestToPurchase(this.orderId, payload);
        this.ShowToast(
          "Éxito",
          "Información ha sido guardada exitosamente.",
          "success"
        );
        this.$emit("close", true);
      } catch (error) {
        this.ShowToast(
          "Error",
          "Ha ocurrido un error al guardar la información. Por favor, intente de nuevo.",
          "error"
        );
        throw error;
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss"></style>
